import { useState, useEffect } from 'react';
import useIndustriesContext from './useIndustriesContext';
import useInstancesContext from './useInstancesContext';
import useSessionContext from './useSessionContext';
import useProgressContext from './useProgressContext';

const useAppBootstrap = () => {
  const [isReady, setReady] = useState(false);
  const { loadIndustries } = useIndustriesContext();
  const { refreshInstances } = useInstancesContext();
  const { loadSession } = useSessionContext();
  const { setLoading } = useProgressContext();

  useEffect(() => {
    setLoading(true);

    (async () => {
      await Promise.all([loadSession(), loadIndustries(), refreshInstances()]);

      // for some reason useUserPermissions() not able to get the eap_access in user
      // initial assessment, provide some delay
      setTimeout(() => {
        setLoading(false);
        setReady(true);
      }, 1000);
    })();
  }, []);

  return isReady;
};

export default useAppBootstrap;
